/**
 * Created by dannyr on 30/11/2016.
 */

import type { ElementType } from "react";
import React from "react";

import classNames from "classnames";

import { PositionUtils } from "app/components/PositionUtils";

import type { IAutoCompleteItemProps, IAutoCompleteValue } from "./types";

interface IAutoCompletePopupProps {
    itemComponent: ElementType;
    emphasisComponent: ElementType;
    onSelect: (item: IAutoCompleteItemProps) => void;
    items: IAutoCompleteValue[];
    query: string;
    popupClass: string;
    width: number;
    selectedItem: number;
    inputElem: HTMLInputElement;
}

interface IAutoCompletePopupState {
    top: number;
    left: number;
}

export class AutoCompletePopup<T> extends React.Component<IAutoCompletePopupProps, IAutoCompletePopupState> {
    // @ts-ignore FIXME: strict migration - TS2564 class field assigned via ref callback; legacy class component lifecycle
    private popupElem: HTMLUListElement;

    constructor(props: IAutoCompletePopupProps) {
        super(props);
        this.state = { top: -500, left: -500 };
    }

    onSelect(item: IAutoCompleteItemProps) {
        return () => this.props.onSelect(item);
    }

    reposition() {
        const appendToBody = true;
        const posResult: {
            top: number;
            left: number;
            placement: string;
        } = PositionUtils.positionElements(this.props.inputElem, this.popupElem, "auto bottom", appendToBody);
        this.setState({ top: posResult.top, left: posResult.left });
    }

    componentDidMount() {
        this.reposition();
    }

    createItemContent(props: IAutoCompleteItemProps) {
        const regExp = new RegExp(`(${props.query})`, "g");
        let current = 0;
        const res = [];

        // traverse occurrences
        props.value.replace(regExp, (match: string, group: string, offset: number) => {
            res.push(props.value.substring(current, offset));
            res.push(
                <this.props.emphasisComponent
                    key={offset}
                    value={props.value}
                    query={props.query}
                >
                    {props.query}
                </this.props.emphasisComponent>,
            );
            current = offset + props.query.length;
            return "";
        });

        // add rest
        res.push(props.value.substring(current));

        return res;
    }

    render() {
        const items = this.props.items.map((item, i) => {
            const classes = classNames("js-dropdown-menu-item", {
                active: this.props.selectedItem == i + 1,
            });
            return (
                <li
                    className={classes}
                    key={item}
                    tabIndex={i + 1}
                    onClick={this.onSelect({ value: item, query: this.props.query })}
                >
                    <this.props.itemComponent
                        value={item}
                        query={this.props.query}
                    >
                        {this.createItemContent({ value: item, query: this.props.query })}
                    </this.props.itemComponent>
                </li>
            );
        });
        return (
            <ul
                className={"typeahead dropdown-menu " + this.props.popupClass}
                ref={(e) => {
                    // @ts-ignore FIXME: strict migration - ref callback receives HTMLUListElement | null; popupElem typed as non-null for legacy access pattern
                    this.popupElem = e;
                }}
                style={{
                    position: "absolute",
                    top: this.state.top,
                    left: this.state.left,
                    width: this.props.width,
                }}
            >
                {items}
            </ul>
        );
    }
}
